import React from "react";
import { Chip } from "@mui/material";

import { PERMISSION_LEVELS } from "../../constants/permissions";

export const PermissionRender = ({ label, flow = "grey" }) => {
  const sx = { fontSize: 10, fontWeight: 500 };
  const props = { label, flow, sx };
  return <Chip variant="colorTag" {...props} />;
};

export const permissionRenderValue = (value) => {
  const op = PERMISSION_LEVELS?.find((o) => o.id === value);
  return <PermissionRender {...op} />;
};
